import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function Logout() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/logout`, null, {
        withCredentials: true,
      });
      localStorage.removeItem("postLoginRedirect");
      setOpen(false);
      navigate("/authentication/sign-in");
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    navigate(-1); // Go back to previous page
  };

  return (
    <Dialog
      open={open}
      onClose={() => !isLoggingOut && handleCancel()}
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 1,
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle>
        <MDTypography variant="h5" fontWeight="medium">
          Confirm Logout
        </MDTypography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <MDTypography variant="body2" color="text">
            Are you sure you want to log out of the CMGFP portal?
          </MDTypography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <MDButton
          variant="text"
          color="secondary"
          onClick={handleCancel}
          disabled={isLoggingOut}
        >
          Cancel
        </MDButton>
        <MDButton
          variant="gradient"
          color="error"
          onClick={handleLogout}
          disabled={isLoggingOut}
          startIcon={isLoggingOut ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isLoggingOut ? "Logging out..." : "Logout"}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default Logout;
